const actionTypes = {
    RETRIEVED_COMMAND_LIST: "RETRIEVED_COMMAND_LIST",
    EXECUTED_COMMAND: "EXECUTED_COMMAND",
    EXECUTED_HELP_COMMAND: "EXECUTED_HELP_COMMAND",
    EXECUTED_LOCAL_COMMAND: "EXECUTED_LOCAL_COMMAND",
    END_PAGING: "END_PAGING",
    CHANGE_USER_MODE: "CHANGE_USER_MODE"
};
export default actionTypes;
